import React from 'react';
import ReactDOM from 'react-dom/client';
import App from '../single-page/App.jsx';
 
const root_div = document.getElementById('root')
const root = ReactDOM.createRoot(root_div);
const props = JSON.parse(root_div.dataset['parameters']);
root.render(
  <React.StrictMode>
    <App flash={props.flash} currentUser={props.currentUser} />
  </React.StrictMode>
);
